export default [
  { id: 'home', src: 'images/backgrounds/home.jpg' },
  { id: 'company', src: 'images/backgrounds/azienda.jpg' },
  { id: 'products', src: 'images/backgrounds/1.jpg' },
  { id: 'engineering', src: 'images/backgrounds/engineering.jpg' },
  { id: 'procurement', src: 'images/backgrounds/procurement.jpg' },
  { id: 'quality', src: 'images/backgrounds/qualita.jpg' },
  { id: 'news', src: 'images/backgrounds/news.jpg' },
  { id: 'contacts', src: 'images/backgrounds/contatti.jpg' }
]



// WEBPACK FOOTER //
// ./src/data/imgData.js